<template>
  <div>
    <template v-if="isSummary">
      <div class="columns">
        <div class="column">
          <summary-item :amount="sellingInfo.listing_price">Listing Price</summary-item>
        </div>
        <div class="column">
          <summary-item :amount="record.actual_profit">Actual Profit</summary-item>
        </div>
      </div>

      <info-item
        label="Closed Date"
        :value="sellingInfo.closing_at"
        is-date
      />
    </template>

    <template v-else>
      <h5 class="selling_status">Status <span>{{ sellingStatus }}</span></h5>
      <hr>

      <!-- Amounts -->
      <div> <!-- Need this div to allow css last-of-type to work -->
        <analysis-item
          label="Listing Price"
          :value="sellingInfo.listing_price"
        />
        <analysis-item
          label="Final Sales Price"
          :value="sellingInfo.final_sales_price"
        />
        <analysis-item
          label="Agent Commission"
          :value="sellingInfo.agent_commission"
          is-percentage
        />
        <analysis-item
          label="Other Selling Costs"
          :value="sellingInfo.other_selling_costs"
        />
      </div>
      <hr>

      <!-- Actual Profit -->
      <profit-item
        type="Actual"
        :amount="record.actual_profit"
        hint="Actual Profit = Final Sales Price - Other Selling Costs - Latest Buying Offer"
      ></profit-item>
      <hr>

      <!-- Dates -->
      <info-heading heading="Dates"></info-heading>
      <info-item
        label="Accepted Date"
        :value="sellingInfo.accepted_at"
        is-date
      />
      <info-item
        label="Contract Date"
        :value="sellingInfo.contracted_at"
        is-date
      />
      <info-item
        label="Closed Date"
        :value="sellingInfo.closing_at"
        is-date
      />
    </template>
  </div>
</template>

<script>
import InfoHeading from "./InfoHeading.vue";
import ProfitItem from "./ProfitItem.vue";
import AnalysisItem from "./AnalysisItem.vue";
import InfoItem from "./InfoItem.vue";
import SummaryItem from "./SummaryItem.vue";
import {ENUMS} from "../../../services/enums";

export default {
  name: "SellingInfoRetailListing",
  components: {
    InfoHeading,
    ProfitItem,
    AnalysisItem,
    InfoItem,
    SummaryItem
  },
  props: {
    sellingInfo: {
      type: Object,
      required: true
    },
    isSummary: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    record() {
      return this.$store.state.activeRecord.record;
    },
    sellingStatus() {
      if(this.sellingInfo.status) {
        return this.$utils.newGetEnumLabel(this.sellingInfo.status, ENUMS.RetailListingSellingInfoStatusEnum);
      }

      return '--'
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

hr {
  margin: 0.75rem (-$modalGutter);
}

.selling_status {
  margin-top: 8px;
  font-weight: bold;

  span {
    float: right;
  }
}
</style>
